import React from 'react';
import styles from "../../IntegrationForm.module.css";
import {SuperchatFields} from "./fields/SuperchatFields";
import {IntegrationFormSelectionProvider, IntegrationRequest, IntegrationRequestPartial} from "../../IntegrationForm";
import {Integration} from "../../../../../../../../../api/generated";
import {ValidationResult} from "../../../../../../../../elements/validator/component/ValidationComponent";
import {useAppSelector} from "../../../../../../../../../app/hooks";
import {Section} from "../../../../../../../../elements/section/Section";
import {ValidatedSelectField} from "../../../../../../../../elements/validator/component/ValidatedSelectField";
import {NotEmptyStringValidator} from "../../../../../../../../elements/validator/Validator";
import {allIntegrationOptions} from "../../../../../../modal/createAndUpdate/components/util/integrationUtil";
import {botIntegrationDataListSelector} from "../../../../slice/integrationsSlice";

interface Props<T> {
    isUpdateForm: boolean
    getMessage: (s: any) => any;
    updateRequest: (update: IntegrationRequestPartial) => void;
    selectionProvider: IntegrationFormSelectionProvider;
    updateValidationStatus: (status: ValidationResult<T>) => void,
}

export const IntegrationData = <T extends IntegrationRequest>({
                                                                  isUpdateForm,
                                                                  getMessage,
                                                                  updateRequest,
                                                                  selectionProvider,
                                                                  updateValidationStatus
                                                              }: Props<T>) => {


    const integration = useAppSelector(selectionProvider.integration)
    const botIntegrationDataList = useAppSelector(botIntegrationDataListSelector)

    const getIntegrationOptions = () => {
        if (isUpdateForm) {
            return allIntegrationOptions
        } else {
            return allIntegrationOptions.filter(o => !botIntegrationDataList.find(i => i.integration === o.value))
        }
    }

    const integrationOptions = getIntegrationOptions()

    const getRequiredFields = () => {
        switch (integration) {
            case Integration.Superchat:
                return <SuperchatFields
                    getMessage={getMessage}
                    updateRequest={updateRequest}
                    selectionProvider={selectionProvider}
                    updateValidationStatus={updateValidationStatus}
                />
            default:
                return <></>
        }
    }

    return <Section title={"Integration Data"}>
        <div className={styles.fieldsLine}>
            <ValidatedSelectField<Integration, T>
                disabled={isUpdateForm}
                onChange={(v: Integration) => updateRequest({integration: v})}
                updateValidationStatus={updateValidationStatus}
                fieldName={'integration'}
                selector={selectionProvider.integration}
                validator={NotEmptyStringValidator}
                label={'Integration'}
                getMessage={getMessage}
                options={integrationOptions}
                selectFirstOptionByDefault={false}
            />
        </div>
        {getRequiredFields()}
    </Section>
}
